import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './login.component';
import { IndexComponent } from './index.component';
import { BuildingComponent } from './commons/building.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'index', component: IndexComponent, children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'building', component: BuildingComponent },
      { path: 'home', loadChildren: () => import('./home/module').then(m => m.Module) },
      { path: 'user', loadChildren: () => import('./user/module').then(m => m.Module) },
      { path: 'task', loadChildren: () => import('./task/module').then(m => m.Module) },
      { path: 'spare', loadChildren: () => import('./spare/module').then(m => m.Module) },
      { path: 'hospital', loadChildren: () => import('./hospital/module').then(m => m.Module) }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class RoutesRouting { }
